// extracted by mini-css-extract-plugin
module.exports = {"page":"pages_page__37JR3","label":"pages_label__1zDFC","views":"pages_views__3I3Kb"};